export default __webpack_public_path__ + "static/media/dot_grey.b8a4fef6.svg";